import { type FormMetadata, getFormProps as getConformFormProps } from '@conform-to/react';
import type { FormEvent } from 'react';

/**
 * Conform's form props, ignoring submit events from other forms. React bubbles events through portals, so a form
 * in a dialog opened from inside this form (e.g. a modal in a table row) would otherwise reach this form's handler,
 * which throws "The submit event is dispatched by form#… instead of form#…".
 */
export const getFormProps = <Schema extends Record<string, unknown>, FormError>(
  metadata: FormMetadata<Schema, FormError>,
  options?: Parameters<typeof getConformFormProps>[1],
) => {
  const props = getConformFormProps(metadata, options);
  return {
    ...props,
    onSubmit: (event: FormEvent<HTMLFormElement>) => {
      if (event.target !== event.currentTarget) return;
      return props.onSubmit(event);
    },
  };
};
